import { Heading } from '@react-email/components';

const headingThree = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Heading as="h3" {...attributes} {...element.attributes}>
                {children}
            </Heading>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return (
            <Heading as="h3" {...attributes}>
                {children}
            </Heading>
        );
    },
};

export default headingThree;
